import cx from "classnames"
import {useHistory} from "react-router-dom"
import {Icon} from "components/Icon"
import {SecondaryButton, BaseButton} from "components/buttons"
import {DigitalDocumentFieldSetUp, TaskType} from "types/tasks"
import styles from "./HeaderBody.module.css"
import {Tooltip} from "antd"

const MAP_FIELD_TYPE_TO_TOOLTIP_TITLE = {
    [DigitalDocumentFieldSetUp.SIGNATURE]: "Signature",
    [DigitalDocumentFieldSetUp.INITIAL]: "Initial",
    [DigitalDocumentFieldSetUp.TEXT]: "Text",
    [DigitalDocumentFieldSetUp.CHECKBOX]: "Checkbox",
    [DigitalDocumentFieldSetUp.SELECT]: "Select",
    [DigitalDocumentFieldSetUp.FILE]: "File",
    [DigitalDocumentFieldSetUp.GRADE]: "Grade"
}

export function HeaderBody({
    type,
    taskId,
    onAddField,
    activeField,
    isSaving,
    getIconByType,
    isEditable,
    onClickSave,
    isDeleted
}) {
    const history = useHistory()

    const onClickCancel = () => {
        history.push(`/tasks/detail?type=${type}&id=${taskId}`)
        window.location.reload()
    }

    const renderActionItem = (type) => {
        const icon = getIconByType(type)
        const isActive = activeField && activeField.type === type

        return (
            <Tooltip title={MAP_FIELD_TYPE_TO_TOOLTIP_TITLE[type]}>
                <div
                    className={cx(styles.headerActionItem, {[styles.headerActionItemActive]: isActive})}
                    onClick={() => {
                        if (isEditable && !isDeleted) {
                            onAddField(type)
                        }
                    }}>
                    <Icon icon={icon} className={styles.headerActionItem__icon} color={isActive ? "#fff" : "#1E90FF"} />
                </div>
            </Tooltip>
        )
    }

    return (
        <div className={styles.headerBody}>
            <div className={styles.headerBodyContent}>
                <p className={styles.headerBodyContent__title}>Create Document</p>
                <div className={styles.headerActionWrap}>
                    {renderActionItem(DigitalDocumentFieldSetUp.SIGNATURE)}
                    {renderActionItem(DigitalDocumentFieldSetUp.INITIAL)}
                    {renderActionItem(DigitalDocumentFieldSetUp.TEXT)}
                    {renderActionItem(DigitalDocumentFieldSetUp.CHECKBOX)}
                    {renderActionItem(DigitalDocumentFieldSetUp.SELECT)}
                    {renderActionItem(DigitalDocumentFieldSetUp.FILE)}
                    {type === TaskType.CUSTOM_DD && renderActionItem(DigitalDocumentFieldSetUp.GRADE)}
                </div>
            </div>
            <div className={styles.headerRightAction}>
                <SecondaryButton title="Cancel" onClick={onClickCancel} />
                {!isDeleted && (
                    <BaseButton
                        title="Save"
                        className={styles.saveBtn}
                        loading={isSaving}
                        disabled={!isEditable}
                        onClick={onClickSave}
                    />
                )}
            </div>
        </div>
    )
}
